
import React from 'react';
import { Modal, Button, Typography, Box } from '@mui/material';

interface BrokerProfileRequiredModalProps {
  open: boolean;
  onClose: () => void;
  sx?: object;
}

const BrokerProfileRequiredModal: React.FC<BrokerProfileRequiredModalProps> = ({ open, onClose }) => {

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="broker-profile-required-modal"
      aria-describedby="broker-profile-required-description"
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)', 
        }}
      >
        <Box
          sx={{
            width: '90%',
            maxWidth: '500px',
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '20px',
            boxShadow: 3,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            '@media (min-width:600px)': { 
              width: '60%',
              padding: '30px',
            },
          }}
        >
          <img
            src="/assets/images/broker2.png" 
            alt="Broker Profile"
            style={{
              width: '100%',
              height: 'auto',
              maxWidth: '200px',
              marginBottom: '20px',
            }}
          />
          <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: '20px' }}>
            ¡Crea tu perfil de Broker!
          </Typography>
          <Typography variant="body1" sx={{ marginBottom: '20px' }}>
            Para poder publicar propiedades como Broker, primero necesitas crear un perfil de Broker.
          </Typography>
          <Box sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', sm: 'row' }, 
            gap: 2, 
            justifyContent: 'center',
          }}>
            <Button
              onClick={() => window.location.href = 'https://alienrealtyweb-admin-cbhmaugqcdbkcnf3.centralus-01.azurewebsites.net/admin-panel/home'}
              sx={{
                backgroundColor: '#4CAF50',
                color: 'white',
                fontWeight: 'bold',
                width: { xs: '100%', sm: '200px' }, 
                padding: '12px',
                '&:hover': {
                  backgroundColor: '#388E3C', 
                },
              }}
            >
              Crear perfil de Broker
            </Button>
            <Button
              onClick={onClose}
              sx={{
                backgroundColor: '#F44336', 
                color: 'white',
                fontWeight: 'bold',
                width: { xs: '100%', sm: '200px' }, 
                padding: '12px',
                '&:hover': {
                  backgroundColor: '#D32F2F', 
                },
              }}
            >
              Cerrar
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default BrokerProfileRequiredModal;
